module.exports = __webpack_public_path__ + "static/media/Full_W_Article_Title.aa090a8c.csv";